'use client';

import { useTenantBranding } from '@/lib/hooks/use-tenant-branding';

/**
 * Tenant brand header for pre-auth pages (login, reset-password, forgot-password).
 *
 * Renders:
 *   - logo image when BrandSettings.logoUrl is set
 *   - otherwise the tenant displayName as a text heading
 *   - nothing while loading, or when host is unmapped (neutral fallback)
 *
 * Designed to sit above the auth Card.
 */
export function TenantBrandHeader() {
  const { loading, branding } = useTenantBranding();

  if (loading || !branding) return null;

  if (branding.logoUrl) {
    return (
      <div className="mb-6 flex justify-center">
        {/* eslint-disable-next-line @next/next/no-img-element -- BrandSettings logoUrl is a tenant-supplied absolute URL; next/image would require allowlisting every tenant host */}
        <img
          src={branding.logoUrl}
          alt={branding.displayName}
          className="h-12 w-auto"
        />
      </div>
    );
  }

  return (
    <div className="mb-6 text-center">
      <h1
        className="text-2xl font-semibold tracking-tight"
        style={branding.primaryColor ? { color: branding.primaryColor } : undefined}
      >
        {branding.displayName}
      </h1>
    </div>
  );
}
